import { render, staticRenderFns } from "./newsxiangqing2.vue?vue&type=template&id=6b9bf6a3&scoped=true"
import script from "./newsxiangqing2.vue?vue&type=script&lang=js"
export * from "./newsxiangqing2.vue?vue&type=script&lang=js"
import style0 from "./newsxiangqing2.vue?vue&type=style&index=0&id=6b9bf6a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9bf6a3",
  null
  
)

export default component.exports